module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "onselectstart": "return false"
    }
  }, [(_vm.selectedItems.length <= 1) ? _c('button', {
    staticClass: "tree-select-single",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.selectedItems.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.selectedItems.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.selectedItems[0].text))]) : _vm._e()]) : _c('div', {
    staticClass: "tree-select-multiple",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, _vm._l((_vm.selectedItems), function(item) {
    return _c('div', {
      staticClass: "tree-select-tag"
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })), _vm._v(" "), _c('i', {
    staticClass: "tree-selec-allow",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tree-select-dropdown"
  }, [_c('v-jstree', {
    ref: "tree",
    attrs: {
      "data": _vm.data,
      "size": _vm.size,
      "showCheckbox": _vm.showCheckbox,
      "allowTransition": _vm.allowTransition,
      "wholeRow": _vm.wholeRow,
      "noDots": _vm.noDots,
      "multiple": _vm.multiple,
      "allowBatch": _vm.allowBatch,
      "textFieldName": _vm.textFieldName,
      "valueFieldName": _vm.valueFieldName,
      "childrenFieldName": _vm.childrenFieldName,
      "async": _vm.async,
      "loadingText": _vm.loadingText
    },
    on: {
      "item-click": _vm.itemClick
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d49e15","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/treeselect.vue
// module id = 14
// module chunks = 0